<!--
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-03-08 14:25:49
-->
<template>
  <div class="wrapper">
    <img :src="resultImg" alt="">
    <h2>上传成功</h2>
    <p>您参与比赛的上传材料阶段已经圆满完成，祝您取得理想成绩。</p>
    <el-button class='btn-warpper' type="default" @click='clickExit'>知道了</el-button>
  </div>
</template>
<script>
export default {
  data () {
    return {
      resultImg: require('@/assets/images/result-img.png')
    }
  },
  methods: {
    clickExit () {
      const searchParams = sessionStorage.getItem('searchParams')
      localStorage.clear()
      sessionStorage.clear()
      this.$router.replace(`${searchParams}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  width: 100%;
  max-width: 686px;
  margin: 0 auto;
  padding-top: 75px;
  text-align: center;
}

img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin-bottom: 20px;
}

h2 {
  font-size: 40px;
  font-weight: bold;
  line-height: 56px;
  margin: 0;
  color: #68BF7B;
}

p {
  font-size: 15px;
  font-weight: 400;
  color: #4E5A73;
  line-height: 28px;
  letter-spacing: 1px;
  margin: 36px 0 47px;
}

.btn-warpper {
  width: 252px;
  height: 60px;
  background: #F04037;
  border-radius: 5px;
  border: 1px solid #C31A12;
  color: #fff;
  font-size: 21px;
  line-height: 60px;
  padding: 0;
  margin: 0 auto;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Result.vue